// icon
import { FaAngleDown } from 'react-icons/fa6';
import { GoArrowUpRight } from 'react-icons/go';
// style
import style from './DeskMenu.module.css';
import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import { motion } from 'framer-motion';

const DesktopMenu = ({ menu }) => {
  const [isHover, setIsHover] = useState(false);

  const toggleHoverMenu = () => {
    setIsHover(!isHover);
  };

  const subMenuAnimate = {
    enter: {
      opacity: 1,
      rotate: 0,
      transition: {
        duration: 0.3,
      },
      display: 'block',
    },
    exit: {
      opacity: 0,
      rotateX: -15,
      transition: {
        duration: 0.3,
      },
      display: 'none',
    },
  };

  const hasSubMenu = menu?.subMenu?.length > 0;

  return (
    <motion.li
      onHoverStart={toggleHoverMenu}
      onHoverEnd={toggleHoverMenu}
      className={style.group}
    >
      {hasSubMenu ? (
        <span className={style.link}>
          {menu.title}
          {hasSubMenu && <FaAngleDown className={style.link_icon} />}
        </span>
      ) : (
        <span className={style.link}>
          <NavLink to={menu.url}>{menu.title}</NavLink>
        </span>
      )}
      {hasSubMenu && (
        <motion.div
          className={style.sub_menu}
          inherit="exit"
          animate={isHover ? 'enter' : 'exit'}
          variants={subMenuAnimate}
        >
          <div>
            {menu?.subMenu?.map((subMenu) => (
              <div key={subMenu.id} className={style.subMenu_link}>
                <NavLink to={subMenu.url}>
                  {subMenu.title} <GoArrowUpRight />
                </NavLink>
              </div>
            ))}
          </div>
        </motion.div>
      )}
    </motion.li>
  );
};
export default DesktopMenu;
